// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.90.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.90.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#outdated {
    font-family: "Roboto", Helvetica, Arial, sans-serif;
    position: absolute;
    background-color: #d8655e;
    color: white;
    display: none;
    overflow: hidden;
    left: 0;
    position: fixed;
    text-align: center;
    text-transform: uppercase;
    top: 0;
    width: 100%;
    z-index: 1500;
    padding: 0 1.5rem 1.5rem 0;
}
#outdated.fullscreen {
    height: 100%;
}
#outdated .vertical-center {
    display: table-cell;
    text-align: center;
    vertical-align: middle;
}
#outdated h6 {
    font-size: 1.5rem;
    line-height: 1.5rem;
    margin: 0.75rem 0;
}
#outdated p {
    font-size: 0.75rem;
    line-height: 0.75rem;
    margin: 0;
}
#outdated #buttonUpdateBrowser {
    border: 0.125rem solid white;
    color: white;
    cursor: pointer;
    display: block;
    margin: 1.5rem auto 0;
    padding: 0.625rem 1.25rem;
    position: relative;
    text-decoration: none;
    width: 14rem;
}
#outdated #buttonUpdateBrowser:hover {
    background-color: white;
    color: #d8655e;
}
#outdated .last {
    height: 1.25rem;
    position: absolute;
    right: 1.5rem;
    top: 0.625rem;
    width: auto;
    display: inline-table;
}
#outdated .last[dir="rtl"] {
    left: 1.5rem !important;
    right: auto !important;
}
#outdated #buttonCloseUpdateBrowser {
    color: white;
    display: block;
    font-size: 2.25rem;
    height: 100%;
    line-height: 2.25rem;
    position: relative;
    text-decoration: none;
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./app/outdated-browser.css"],"names":[],"mappings":"AAAA;IACI,mDAAmD;IACnD,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,OAAO;IACP,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,MAAM;IACN,WAAW;IACX,aAAa;IACb,0BAA0B;AAC9B;AACA;IACI,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,SAAS;AACb;AACA;IACI,4BAA4B;IAC5B,YAAY;IACZ,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,uBAAuB;IACvB,cAAc;AAClB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;AACf","sourcesContent":["#outdated {\n    font-family: \"Roboto\", Helvetica, Arial, sans-serif;\n    position: absolute;\n    background-color: #d8655e;\n    color: white;\n    display: none;\n    overflow: hidden;\n    left: 0;\n    position: fixed;\n    text-align: center;\n    text-transform: uppercase;\n    top: 0;\n    width: 100%;\n    z-index: 1500;\n    padding: 0 1.5rem 1.5rem 0;\n}\n#outdated.fullscreen {\n    height: 100%;\n}\n#outdated .vertical-center {\n    display: table-cell;\n    text-align: center;\n    vertical-align: middle;\n}\n#outdated h6 {\n    font-size: 1.5rem;\n    line-height: 1.5rem;\n    margin: 0.75rem 0;\n}\n#outdated p {\n    font-size: 0.75rem;\n    line-height: 0.75rem;\n    margin: 0;\n}\n#outdated #buttonUpdateBrowser {\n    border: 0.125rem solid white;\n    color: white;\n    cursor: pointer;\n    display: block;\n    margin: 1.5rem auto 0;\n    padding: 0.625rem 1.25rem;\n    position: relative;\n    text-decoration: none;\n    width: 14rem;\n}\n#outdated #buttonUpdateBrowser:hover {\n    background-color: white;\n    color: #d8655e;\n}\n#outdated .last {\n    height: 1.25rem;\n    position: absolute;\n    right: 1.5rem;\n    top: 0.625rem;\n    width: auto;\n    display: inline-table;\n}\n#outdated .last[dir=\"rtl\"] {\n    left: 1.5rem !important;\n    right: auto !important;\n}\n#outdated #buttonCloseUpdateBrowser {\n    color: white;\n    display: block;\n    font-size: 2.25rem;\n    height: 100%;\n    line-height: 2.25rem;\n    position: relative;\n    text-decoration: none;\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
